import i18n from '@/i18n';
import {
  LOCAL_STORAGE_KEY_LANGUAGE,
  LOCAL_STORAGE_KEY_DARK_THEME_ENABLED,
  LOCAL_STORAGE_KEY_SCROLL_OFF_NAVBAR,
} from './constants';

export default {
  SET_SIDEBAR_OPENED: (state, opened) => {
    state.sidebar.opened = opened;
  },
  SET_INIT: (state, val) => {
    state.init = val;
  },
  SET_LOADING: (state, val) => {
    state.isLoading = val;
  },
  ADD_DELAYED_MODULE: (state, val) => {
    state.delayedModules = [...state.delayedModules, val];
  },
  REMOVE_DELAYED_MODULE: (state, val) => {
    state.delayedModules = state.delayedModules.filter((row) => row !== val);
  },
  SET_MODAL_OPENED_IN_ROUTE: (state, routes) => {
    state.modal.isOpen = routes;
  },
  SET_MODAL_FULLSCREEN: (state, fullscreen) => {
    state.modal.isFullscreen = fullscreen;
  },
  SET_MODAL_INITIAL_TAB: (state, value) => {
    state.modal.initialTab = value;
  },
  SET_RIGHT_SIDEBAR_OPENED: (state, opened) => {
    state.sidebar.right.opened = opened;
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language;
    i18n.locale = language;
    window.localStorage.setItem(LOCAL_STORAGE_KEY_LANGUAGE, language);
  },
  SET_AUTHENTICATED: (state, authenticated) => {
    state.authenticated = authenticated;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_DARK_THEME: (state, darkThemeEnabled) => {
    state.darkThemeEnabled = darkThemeEnabled;
    window.localStorage.setItem(
      LOCAL_STORAGE_KEY_DARK_THEME_ENABLED,
      JSON.stringify(darkThemeEnabled)
    );
  },
  SET_SCROLL_OFF_NAVBAR: (state, scrollOffNavbarEnabled) => {
    state.scrollOffNavbarEnabled = scrollOffNavbarEnabled;
    window.localStorage.setItem(
      LOCAL_STORAGE_KEY_SCROLL_OFF_NAVBAR,
      JSON.stringify(scrollOffNavbarEnabled)
    );
  },
};
